module.exports = __webpack_public_path__ + "static/media/Neuvo.63caf4a1.png";